import { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import { combineStyles } from 'helpers/helpers';
import { get, post, put } from 'helpers/apiHelpers';
import withStyles from '@material-ui/core/styles/withStyles';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle';
import validationFormsStyle from 'assets/jss/material-dashboard-pro-react/views/validationFormsStyle';
import { fetchDiets } from 'actions/Diets';
import { fetchVariants } from 'actions/Variants';
import SweetAlert from 'react-bootstrap-sweetalert';
import sweetAlertStyle from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx';
import { toast } from 'react-toastify';

const DietPrices = WrappedComponent =>
  // eslint-disable-next-line react/display-name -- FIXME
  class extends Component {
    state = {
      alert: null,
      selectedDiet: {},
      dietCosts: [],
      selectedDietCosts: [],
      isLoading: true,
      showSubscriptionAlert: false,
    };

    componentDidMount() {
      Promise.all([
        this.props.fetchDiets(),
        this.props.fetchVariants(),
        get('/diet-costs', { pagination: false }),
        // eslint-disable-next-line promise/prefer-await-to-then, @typescript-eslint/no-unused-vars -- FIXME
      ]).then(([diets, variants, dietCostsData]) => {
        const data = dietCostsData['hydra:member'];

        if (this.props.diets.length > 0) {
          this.setState({
            dietCosts: data,
            selectedDiet: this.props.diets[0]['@id'],
          });
        }
        this.setState({ isLoading: false });

        this.propagateData(data);
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- FIXME
        this.props.diets.length > 0 &&
          this.filterDietCosts(this.props.diets[0]['@id']);
      });
    }

    propagateData = dietCostsData => {
      const dietCosts = [];
      this.props.diets.forEach(diet => {
        this.props.variants.forEach(variant => {
          if (!diet.variants.includes(variant['@id'])) {
            return;
          }

          variant.calories.forEach(calorie => {
            let dietCost = dietCostsData.find(
              // eslint-disable-next-line no-shadow -- FIXME
              dietCost =>
                dietCost.calorific === calorie['@id'] &&
                dietCost.diet === diet['@id']
            );

            if (dietCost === undefined) {
              dietCost = null;
            }

            return dietCosts.push({
              hasChanged: false,
              '@id': dietCost?.['@id'] ?? null,
              dietName: diet.name,
              diet: diet['@id'],
              variantName: variant.name,
              calorific: calorie['@id'],
              calorificName: calorie.name,
              hasUpdateActiveSubscriptions: false,
              price: dietCost?.price ?? 0,
              priceForTest: dietCost?.priceForTest ?? 0,
              priceForSubscription: dietCost?.priceForSubscription ?? 0,
              expectedFoodCost: dietCost?.expectedFoodCost ?? 0,
              vat: dietCost?.vat ?? 0,
              _price: dietCost?.price ?? 0,
              _priceForTest: dietCost?.priceForTest ?? 0,
              _priceForSubscription: dietCost?.priceForSubscription ?? 0,
              _expectedFoodCost: dietCost?.expectedFoodCost ?? 0,
              _vat: dietCost?.vat ?? 0,
            });
          });
        });
      });

      this.setState({
        dietCosts,
      });
    };

    filterDietCosts = selectedDiet => {
      const filteredDietCosts = this.state.dietCosts.filter(
        dietCost => dietCost.diet === selectedDiet
      );
      this.setState({
        selectedDietCosts: filteredDietCosts,
      });
    };

    // eslint-disable-next-line consistent-return -- FIXME
    handleDietChange = (event, selectedDiet) => {
      if (this.state.selectedDietCosts.some(dietCost => dietCost.hasChanged)) {
        return this.confirmModal(selectedDiet['@id']);
      }
      this.filterDietCosts(selectedDiet['@id']);
      this.setState({
        selectedDiet: selectedDiet['@id'],
      });
    };

    handleChange = (event, index) => {
      const { selectedDietCosts } = this.state;
      const elToChange = selectedDietCosts[index];
      let key = event.target.name;
      if (
        ![
          'price',
          'priceForTest',
          'priceForSubscription',
          'expectedFoodCost',
        ].includes(key)
      ) {
        key = 'vat';
      }

      const newValue = event.target.value.replace(/,/g, '.');
      const isValid = /^[0-9,.]*$/.test(newValue);
      if (!isValid || isNaN(newValue)) {
        return;
      }
      elToChange[key] = newValue;

      elToChange.hasChanged =
        // eslint-disable-next-line no-underscore-dangle -- FIXME
        parseFloat(elToChange.price) !== elToChange._price ||
        // eslint-disable-next-line no-underscore-dangle -- FIXME
        parseFloat(elToChange.priceForTest) !== elToChange._priceForTest ||
        parseFloat(elToChange.priceForSubscription) !==
          // eslint-disable-next-line no-underscore-dangle -- FIXME
          elToChange._priceForSubscription ||
        parseFloat(elToChange.expectedFoodCost) !==
          // eslint-disable-next-line no-underscore-dangle -- FIXME
          elToChange._expectedFoodCost ||
        // eslint-disable-next-line no-underscore-dangle -- FIXME
        parseFloat(elToChange.vat) !== elToChange._vat;

      this.setState({
        selectedDietCosts,
      });
    };

    confirmModal = selectedDiet =>
      this.setState({
        alert: (
          <SweetAlert
            warning={true}
            style={{ display: 'block' }}
            title="Wprowadzono zmiany. Czy chcesz je zapisać?"
            onConfirm={async () => {
              await this.saveAll();
              this.setState({ selectedDiet });
              this.filterDietCosts(selectedDiet);
              this.hideAlert();
            }}
            onCancel={() => {
              this.hideAlert();
              const resetDietCosts = this.state.dietCosts.map(dc => {
                if (dc.hasChanged) {
                  return {
                    ...dc,
                    hasChanged: false,
                    hasUpdateActiveSubscriptions: false,
                    // eslint-disable-next-line no-underscore-dangle -- FIXME
                    price: dc._price,
                    // eslint-disable-next-line no-underscore-dangle -- FIXME
                    priceForTest: dc._priceForTest,
                    // eslint-disable-next-line no-underscore-dangle -- FIXME
                    priceForSubscription: dc._priceForSubscription,
                    // eslint-disable-next-line no-underscore-dangle -- FIXME
                    expectedFoodCost: dc._pexpectedFoodCost,
                    // eslint-disable-next-line no-underscore-dangle -- FIXME
                    vat: dc._vat,
                  };
                }
                return dc;
              });
              this.setState({
                selectedDiet,
                dietCosts: resetDietCosts,
              });
              this.filterDietCosts(selectedDiet);
            }}
            confirmBtnCssClass={`${this.props.classes.button} ${this.props.classes.success}`}
            cancelBtnCssClass={`${this.props.classes.button} ${this.props.classes.danger}`}
            confirmBtnText="Tak"
            cancelBtnText="Nie"
            showCancel={true}
          ></SweetAlert>
        ),
      });

    hideAlert = () => {
      this.setState({
        alert: null,
      });
    };

    validateForm = () => {
      const { t } = this.props;
      const { selectedDietCosts } = this.state;
      let isValid = true;
      if (
        selectedDietCosts.some(
          dietCost =>
            dietCost.price === '' ||
            dietCost.priceForTest === '' ||
            dietCost.priceForSubscription === '' ||
            dietCost.vat === ''
        )
      ) {
        isValid = false;
        toast.error(t('errors.priceAndVatRequired'));
      }
      return isValid;
    };

    confirmSubscriptionPriceModal = () =>
      this.setState(prevState => ({
        ...prevState,
        showSubscriptionAlert: true,
      }));

    saveAll = () => {
      if (
        this.state.selectedDietCosts.some(
          ({ hasChanged, priceForSubscription, _priceForSubscription }) =>
            hasChanged && priceForSubscription !== _priceForSubscription
        )
      ) {
        return this.confirmSubscriptionPriceModal();
      }

      return this.saveAllNoSubscriptionModal();
    };

    saveAllNoSubscriptionModal = () => {
      const { t } = this.props;
      if (!this.validateForm()) {
        return;
      }

      const { selectedDietCosts } = this.state;
      selectedDietCosts.forEach(dietCost => {
        if (dietCost.price !== '') {
          dietCost.price = parseFloat(dietCost.price);
        }
        if (dietCost.priceForTest !== '') {
          dietCost.priceForTest = parseFloat(dietCost.priceForTest);
        }
        if (dietCost.priceForSubscription !== '') {
          dietCost.priceForSubscription = parseFloat(
            dietCost.priceForSubscription
          );
        }
        if (
          dietCost.expectedFoodCost !== '' &&
          dietCost.expectedFoodCost !== null
        ) {
          dietCost.expectedFoodCost = parseFloat(dietCost.expectedFoodCost);
        } else {
          dietCost.expectedFoodCost = null;
        }
        if (dietCost.vat !== '') {
          dietCost.vat = parseFloat(dietCost.vat);
        }

        dietCost.hasUpdateActiveSubscriptions = true;
      });

      // eslint-disable-next-line consistent-return -- FIXME
      return Promise.all(
        selectedDietCosts.map(dietCost => {
          if (dietCost.hasChanged) {
            return dietCost['@id']
              ? put(dietCost['@id'], dietCost)
              : post('/diet-costs', dietCost);
          }
          return null;
        })
        // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      ).then(
        () => {
          selectedDietCosts.forEach(dietCost => {
            dietCost.hasChanged = false;
          });
          toast.success(t('success.changesSaved'));
          this.setState({
            selectedDietCosts: selectedDietCosts.map(dietCost => ({
              ...dietCost,
              _price: dietCost.price,
              _priceForTest: dietCost.priceForTest,
              _priceForSubscription: dietCost.priceForSubscription,
              _expectedFoodCost: dietCost.expectedFoodCost,
              _vat: dietCost.vat,
              hasUpdateActiveSubscriptions: false,
            })),
          });
        },
        // eslint-disable-next-line promise/prefer-await-to-callbacks -- FIXME
        error => {
          toast.error(error.response.data['hydra:description']);
        }
      );
    };

    render() {
      const { t } = this.props;

      return (
        <>
          <WrappedComponent
            {...this.state}
            {...this.props}
            classes={this.props.classes}
            submitForm={this.submitForm}
            handleDietChange={this.handleDietChange}
            getInputValue={this.getInputValue}
            handleChange={this.handleChange}
            saveCalorificPrice={this.saveCalorificPrice}
            saveAll={this.saveAll}
          />

          {this.state.showSubscriptionAlert && (
            <SweetAlert
              title={t('priceLists.diets.subscriptionModal.title')}
              onConfirm={() => {
                this.saveAllNoSubscriptionModal();
                this.setState({ showSubscriptionAlert: false });
              }}
              onCancel={() => this.setState({ showSubscriptionAlert: false })}
              confirmBtnCssClass={`${this.props.classes.button} ${this.props.classes.success}`}
              cancelBtnCssClass={`${this.props.classes.button} ${this.props.classes.danger}`}
              confirmBtnText={t('common.shared.save', 'Zapisz')}
              cancelBtnText={t('common.loginForm.buttonBack', 'Wróć')}
              showCancel={true}
              type="controlled"
              dependencies={[this.state.counter]}
            >
              <div
                style={{ marginBottom: '20px' }}
                dangerouslySetInnerHTML={{
                  __html: t('priceLists.diets.subscriptionModal.content', {
                    interpolation: { escapeValue: false },
                  }),
                }}
              />
              {this.state.selectedDietCosts.map(dietCost => {
                if (
                  dietCost.hasChanged &&
                  dietCost.priceForSubscription !==
                    // eslint-disable-next-line no-underscore-dangle -- FIXME
                    dietCost._priceForSubscription
                ) {
                  return (
                    // eslint-disable-next-line react/jsx-key -- FIXME
                    <div>
                      {`${dietCost.dietName}, ${dietCost.variantName} (${dietCost.calorificName})`}
                    </div>
                  );
                }

                return null;
              })}
            </SweetAlert>
          )}
        </>
      );
    }
  };

const combinedStyles = combineStyles(
  extendedFormsStyle,
  validationFormsStyle,
  buttonsStyle,
  sweetAlertStyle
);

const mapStateToProps = state => ({
  diets: state.Diets.diets,
  variants: state.Variants.variants,
});

const mapDispatchToProps = {
  fetchDiets,
  fetchVariants,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(combinedStyles),
  withTranslation(),
  DietPrices
);
